import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PureCounter from '@srexi/purecounterjs';
import WhyChooseUs from './Home/WhyChooseUs';
import Consultation from './Home/Consultation';
import Services from './Home/Services';
import WorkProcess from './Home/WorkProcess';
import About from './Home/About';
import Hero from './Home/Hero';
import ContactUs from './ContactUs';
import Solutions from './Home/Solutions';

function Home() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    new PureCounter();
  }, []);

  return (
    <>
     
      <Hero/>

      <About/>

      <WorkProcess/>

      <Services/>

      <Solutions/>

      {/* <Team/> */}

      <Consultation/>

      <WhyChooseUs/>

      <ContactUs/>

      {/* <section id="contact" className="contact section">
       
        <div className="container section-title mt-4">
          <div>
            <span>Contact</span> <span className="description-title">Us</span>
          </div>
        </div>
      

        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-info">
                <div className="contact-card">
                  <h3>Contact Information</h3>
                  <p>
                    Feel free to reach out with any questions about the book,
                    speaking engagements, or media inquiries.
                  </p>

                  <div className="contact-details">
                    <div className="contact-item">
                      <i className="bi bi-envelope"></i>
                      <div>
                        <h4>Email:</h4>
                        <p>author@example.com</p>
                      </div>
                    </div>

                    <div className="contact-item">
                      <i className="bi bi-telephone"></i>
                      <div>
                        <h4>Phone:</h4>
                        <p>+1 (555) 123-4567</p>
                      </div>
                    </div>

                    <div className="contact-item">
                      <i className="bi bi-geo-alt"></i>
                      <div>
                        <h4>Address:</h4>
                        <p>123 Book Street, Literary Lane</p>
                        <p>Wordsmith City, NY 10001</p>
                      </div>
                    </div>
                  </div>

                  <div className="social-links">
                    <a href="#"><i className="bi bi-twitter"></i></a>
                    <a href="#"><i className="bi bi-facebook"></i></a>
                    <a href="#"><i className="bi bi-instagram"></i></a>
                    <a href="#"><i className="bi bi-linkedin"></i></a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="contact-form-wrapper">
                <form
                  action="forms/contact.php"
                  method="post"
                  className="php-email-form"
                >
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label for="name">Your Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="John Doe"
                        required=""
                      />
                    </div>
                    <div className="col-md-6 form-group mt-3 mt-md-0">
                      <label for="email">Your Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="john@example.com"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <label for="subject">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      id="subject"
                      placeholder="I loved your book!"
                      required=""
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label for="message">Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      rows="7"
                      placeholder="Your message here..."
                      required=""
                    ></textarea>
                  </div>

                  <div className="my-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your message has been sent. Thank you!
                    </div>
                  </div>

                  <div className="text-center">
                    <button type="submit">Send Message</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className='container mt-5' style={{ width: '100%', height: '450px' }}>
            <iframe
                title="Google Map Location"
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3649.6840836259535!2d90.4136566737356!3d23.8298304286163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNikunja-2%2C%20Khilkhet%2C%20Dhaka-1229%20(Opposite%20Site%20Of%20Nagorik%20Television)%20%20(Unique%20Studio%20Building)!5e0!3m2!1sen!2sbd!4v1751950782070!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
      </section> */}
    </>
  );
}

export default Home;
